import type { Ref } from 'react';

import Tooltip from '@/components/atoms/Tooltip';

import LinkButton from './LinkButton';
import NativeButton from './NativeButton';
import { type ButtonProps, isLinkProps } from './types';

import styles from './button.module.scss';

export type { ButtonProps, ButtonSize, ButtonVariant } from './types';

/**
 * The portal's one button. `primary` is the blue main action with a white label in both
 * themes, `secondary` is outlined, `danger` is for destructive
 * actions. With `to` it renders a router link that looks like a button.
 */
export function Button(props: ButtonProps & { ref?: Ref<HTMLButtonElement> }) {
    const { ref, tooltip, tooltipPlacement = 'top' } = props;

    // A link takes no button ref, as before.
    const button = isLinkProps(props) ? (
        <LinkButton {...props} />
    ) : (
        <NativeButton {...props} ref={ref} />
    );

    if (tooltip === undefined || tooltip === null || tooltip === '') {
        return button;
    }

    return (
        <Tooltip
            content={tooltip}
            placement={tooltipPlacement}
            layout="inline"
            targetClassName={styles.tooltipTarget}>
            {button}
        </Tooltip>
    );
}

export default Button;
